module.exports = __webpack_public_path__ + "img/vuelo4.4de9c748.jpg";